/** Premade menu item for a "gear menu" (settings menu). */
export const gearMenuItem = {
    key: 'gearMenu',
    title: 'Settings',
    iconProps: { iconName: 'Settings' },
    buttonStyles: {
        root: {
            backgroundColor: 'transparent',
        },
    },
};
/** Premade menu item that links to MS privacy notice */
export const privacyMenuItem = ({ text = 'Privacy and cookies', } = {}) => ({
    key: 'Privacy and cookies',
    text,
    iconProps: { iconName: 'RedEye' },
    href: 'https://privacy.microsoft.com/privacystatement',
    rel: 'noopener noreferrer',
    target: '_blank',
});
/** Premade menu item that links to MS employee privacy notice */
export const privacyEmployeeMenuItem = {
    key: 'Privacy and cookies',
    text: 'Privacy and cookies',
    title: 'Microsoft Global Data Privacy Notice for Employees, External Staff, Candidates and Guests',
    iconProps: { iconName: 'RedEye' },
    href: 'https://privacy.microsoft.com/data-privacy-notice',
    rel: 'noopener noreferrer',
    target: '_blank',
};
/** Premade menu item that links to MSRC blog */
export const blogMenuItem = {
    key: 'MSRC Blog',
    text: 'MSRC Blog',
    iconProps: { iconName: 'Blog' },
    href: 'https://aka.ms/msrc-blog',
    rel: 'noopener noreferrer',
    target: '_blank',
};
/** Premade "copyright Microsoft YYYY" menu item */
export const copyrightMenuItem = {
    key: 'Copyright',
    disabled: true,
    text: `© Microsoft ${new Date().getFullYear()}`,
};
/** Premade context menu item that shows a feedback icon and takes the user to the feedback form */
export const getFeedbackMenuItem = ({ href, stringsFeedbackItem: { text = 'Feedback and support' } = {}, }) => ({
    key: 'feedback',
    text,
    title: text,
    ariaLabel: text,
    iconProps: {
        iconName: 'Feedback',
    },
    rel: 'noopener noreferrer',
    target: '_blank',
    href,
});
